export interface TableCellBaseProps<CellType = unknown> {
  cellType: CellType;
  cellHoverDisabled?: boolean;
}
